module.exports = __webpack_public_path__ + "static/img/8-3.9b51d0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/8-3.jpg
// module id = raCK
// module chunks = 0